import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

export const setWebpackPublicPath = () => {
  const url = new URL(document.currentScript.src);
  const newPath = url.pathname.substring(0, url.pathname.lastIndexOf('/'));
  const publicPath = `${newPath}/${__webpack_public_path__}`.replace(/\/$/, '');
  __webpack_public_path__ = publicPath;
};

export const reactInsightsPlugin = new ReactPlugin();
export const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.MICROSOFT_METRICTS,
    enableAutoRouteTracking: true,
    extensions: [reactInsightsPlugin],
  },
});

export const initErrorMonitoring = () => {
  if (process.env.NODE_ENV !== 'development') {
    appInsights.loadAppInsights();
    appInsights.trackPageView();
  }
};

export const insertAdminAreaOnlyStyles = () => {
  const bodyCheck = setInterval(() => {
    if (document.body) {
      clearInterval(bodyCheck);
      const getQuote = document.body.id.includes('getquote');
      if (!getQuote || process.env.NODE_ENV === 'development') {
        document.documentElement.style.fontSize = '10px';
      }
    }
  }, 100);
};
